import { OccConfig } from '@spartacus/core';

export const approvalsPageOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        myRequests: '/users/${userId}/approval-requests',
        requestsDetails: '/users/${userId}/approval-requests/${codeRequest}',
        replyRequest: '/users/${userId}/approval-requests/${codeRequest}/${status}', // approve | reprove
      } as any,
    },
  },
};
